import axios from 'axios';

export const fetchBranchesByLocation = (chiefdomId: number) =>
  axios({
    method: 'GET',
    url: '/user-service/user/tagged-branches',
    params: { chiefdomId }
  });
